const testimonials = [
  {
    name: "Alexandra W.",
    location: "Palm Beach, FL",
    rating: 5,
    text: "We were scheduled to depart PBI for London the week after Easter and realized my husband's passport expired in June. The six-month rule would have denied him boarding. Fast Passport Center had his renewed passport in hand within four business days. We made our flight without issue. Their discretion and professionalism were exactly what one expects in Palm Beach.",
    service: "Passport Renewal",
  },
  {
    name: "William T.",
    location: "Wellington, FL",
    rating: 5,
    text: "My daughter was competing at Spruce Meadows in Calgary and her passport — a five-year child passport — had expired two months before without anyone noticing. The show entry deadline was already past. Fast Passport Center processed her renewal in three days and we made the competition. As an equestrian family, we now verify every rider's passport at the start of each season.",
    service: "Child Passport",
  },
  {
    name: "Catherine M.",
    location: "Palm Beach, FL",
    rating: 5,
    text: "We had a last-minute weather window for a yacht departure to the Bahamas and discovered our grandson's passport had been damaged in a pool bag. Fast Passport Center handled the replacement in under 48 hours from when we shipped the documents. The captain was impressed — and so were we. They clearly understand the urgency of yacht schedules.",
    service: "Damaged Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PalmBeachTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Palm Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Palm Beach, Wellington, and South Florida residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}